import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { inputCls } from "@/lib/constants";
import { toast } from "sonner";
import { Loader2, ArrowLeft, Mail, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 hover:text-slate-800 mb-6"><ArrowLeft size={15} /> Back to sign in</Link>
        {sent ? (
          <div data-testid="forgot-success" className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 text-center">
            <div className="w-14 h-14 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto"><CheckCircle2 size={30} /></div>
            <h2 className="text-xl font-extrabold text-slate-900 font-heading mt-4">Check your inbox</h2>
            <p className="text-sm text-slate-500 mt-2">If an account exists for <span className="font-medium text-slate-700">{email}</span>, we've emailed a password reset link. It expires in 1 hour.</p>
          </div>
        ) : (
          <>
            <div className="w-11 h-11 rounded-xl bg-emerald-100 text-emerald-600 flex items-center justify-center mb-4"><Mail size={22} /></div>
            <h2 className="text-2xl font-extrabold text-slate-900 font-heading">Forgot password?</h2>
            <p className="text-sm text-slate-500 mt-1 mb-6">Enter your account email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="block text-xs font-semibold text-slate-700 mb-1.5 uppercase tracking-wider">Email</label>
                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@arjunfintech.com" />
              </div>
              <button data-testid="forgot-submit-button" type="submit" disabled={loading} className="w-full px-4 py-2.5 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white font-semibold text-sm transition-all shadow-sm active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50">
                {loading ? <Loader2 size={18} className="animate-spin" /> : "Send reset link"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
